import "hlsjs";

// why?
/* global Hls */

let recoverDecodingErrorDate, recoverSwapAudioCodecDate;
const handleMediaError = (hls, player) => {
  const now = performance.now();

  if (!recoverDecodingErrorDate || now - recoverDecodingErrorDate > 5000) {
    recoverDecodingErrorDate = performance.now();
    console.log("try to recover media Error ...");
    hls.recoverMediaError();
    player.play();
  } else if (
    !recoverSwapAudioCodecDate ||
    now - recoverSwapAudioCodecDate > 5000
  ) {
    recoverSwapAudioCodecDate = performance.now();
    console.log("try to swap Audio Codec and recover media Error ...");
    hls.swapAudioCodec();
    hls.recoverMediaError();
    player.play();
  } else {
    console.log("cannot recover, last media error recovery failed ...");
  }
};

export default function hlsjsHandleErrors(hls, player) {
  player.on("error", () => {
    if (player.error().code === 3) {
      handleMediaError(hls, player);
    }
  });

  // MediaError.errorTypes;
  hls.on(Hls.Events.ERROR, (event, data) => {
    switch (data.details) {
      case Hls.ErrorDetails.MANIFEST_LOAD_ERROR:
        console.log(`manifest_load_error url:${data.context.url}`);
        window.alert(`manifest_load_error url:${data.context.url}`);
        break;
      case Hls.ErrorDetails.MANIFEST_LOAD_TIMEOUT:
        window.alert(`manifest_load_timeout`);
        break;
      case Hls.ErrorDetails.MANIFEST_PARSING_ERROR:
        window.alert(`error while parsing manifest:${data.reason}`);
        break;
      case Hls.ErrorDetails.LEVEL_LOAD_ERROR:
        console.log("error while loading level playlist");
        break;
      case Hls.ErrorDetails.LEVEL_LOAD_TIMEOUT:
        console.log("timeout while loading level playlist");
        break;
      case Hls.ErrorDetails.LEVEL_SWITCH_ERROR:
        console.log(`error while trying to switch to level ${data.level}`);
        break;
      case Hls.ErrorDetails.FRAG_LOAD_ERROR:
        console.log(`error while loading fragment ${data.frag.url}`);
        break;
      case Hls.ErrorDetails.FRAG_LOAD_TIMEOUT:
        console.log(`timeout while loading fragment ${data.frag.url}`);
        break;
      case Hls.ErrorDetails.FRAG_LOOP_LOADING_ERROR:
        console.log("Frag Loop Loading Error");
        break;
      case Hls.ErrorDetails.FRAG_DECRYPT_ERROR:
        console.log(`Decrypting Error:${data.reason}`);
        break;
      case Hls.ErrorDetails.FRAG_PARSING_ERROR:
        console.log(`Parsing Error:${data.reason}`);
        break;
      case Hls.ErrorDetails.KEY_LOAD_ERROR:
        console.log(`error while loading key ${data.frag.decryptdata.uri}`);
        break;
      case Hls.ErrorDetails.KEY_LOAD_TIMEOUT:
        console.log(`timeout while loading key ${data.frag.decryptdata.uri}`);
        break;
      case Hls.ErrorDetails.BUFFER_APPEND_ERROR:
        console.log("Buffer Append Error");
        break;
      case Hls.ErrorDetails.BUFFER_ADD_CODEC_ERROR:
        console.log(
          `Buffer Add Codec Error for ${data.mimeType}:${data.err.message}`,
        );
        break;
      case Hls.ErrorDetails.BUFFER_APPENDING_ERROR:
        console.log("Buffer Appending Error");
        break;
      default:
        break;
    }
    if (data.fatal) {
      console.log(`fatal error :${data.details}`);
      switch (data.type) {
        case Hls.ErrorTypes.MEDIA_ERROR:
          handleMediaError(hls, player);
          break;
        case Hls.ErrorTypes.NETWORK_ERROR:
          console.log(",network error ...");
          hls.startLoad();
          break;
        default:
          console.log(", unrecoverable error");
          hls.destroy();
          break;
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/js/hlsjs/handle_errors.js